export default __webpack_public_path__ + "static/media/model-registerstep-new.3e1ddc5d.jpg";